<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <lg-form-input v-model="form.descricao" label="Descrição:" description=" " cols="6" sm="6" md="6" />

                    <b-col cols="1">
                        <b-button id="limpar" v-b-tooltip.hover.top="'Limpar'" class="my-2" size="sm"
                            style="height: 40px" pill variant="primary" @click="limpar">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                        </b-button>

                    </b-col>
                    <b-col cols="1" class="mt-2">
                        <b-button id="localizar" v-b-tooltip.hover.top="'Localizar'" class="mr-2 my-2" size="sm"
                            style="height: 20px" pill variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" /> &nbsp;
                            </div>
                        </b-button>

                    </b-col>


                    <b-col cols="1" class="text-right mt-2">
                        <b-button id="novo" v-b-tooltip.hover.top="'Adicioar novo...'" class=" my-2" size="sm"
                            variant="primary" @click="mostrarModal">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" /> &nbsp;
                            </div>
                        </b-button>

                    </b-col>
                </b-form-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty @row-dblclicked="rowSelect">

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>


                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template v-slot:cell(dataInicio)="row">
                        {{ formatDate(row.item.dataInicio) }}
                    </template>

                    <template v-slot:cell(dataFim)="row">
                        {{ formatDate(row.item.dataFim) }}
                    </template>

                    <template v-slot:cell(status)="data">
                        <b-badge :variant="badgeVariant(compareFormattedDates(data.item.dataInicio, data.item.dataFim))"
                            class="badge">
                            {{ formatSituacao(compareFormattedDates(data.item.dataInicio, data.item.dataFim)) }}
                        </b-badge>
                    </template>


                    <template v-slot:cell(action)="row">
                        <b-button :id="row.index + 'edit-button'" class="my-2" size="sm" pill variant="primary"
                            @click="editar(row.item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="row.index + 'edit-button'" title="Editar..."></b-tooltip>
                        </b-button>

                    </template>


                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>

        <GarantiaContratoListForm v-if="show" @close="cancelar" :prefix="prefix + title + ' > '" :id="id" />


    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import GarantiaContratoListForm from "./GarantiaContratoListForm.vue";
import ConfirmMixin from "@/core/mixins/confirm"

export default {
    components: {
        LgFormInput,
        GarantiaContratoListForm,
    },
    props: {
        prefix: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            title: 'Garantia Contrato',
            id: null,
            show: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            form: {
                descricao: "",
            },
        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/garantia-contrato`);
        this.load();
    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        tableFields() {
            return [
                { key: "descricao", label: "Descrição" },

                { key: "valor", label: "Valor" },
                { key: "tipoGarantiaContrato.descricao", label: "Tipo de Garantia" },
                { key: "dataInicio", label: "Data de Inicio" },
                { key: "dataFim", label: "Data Final" },
                { key: "status", label: "Status" },
                { key: "action", label: " ", tdClass: "w-1" },

            ];
        },
    },
    methods: {
        compareFormattedDates(dateA, dateB) {
            const toISO = d => {
                const [day, month, year] = d.split('/');
                return `${year}-${month}-${day}`;
            };

            const a = new Date(toISO(dateA));
            const b = new Date(toISO(dateB));

            if (a < b) return 1;

            return 0;
        },

        formatDate(dateString) {
            if (!dateString) return "N/A";

            const [datePart] = dateString.split("T");
            const [year, month, day] = datePart.split("-");

            return `${day}/${month}/${year}`;
        },
        formatSituacao(situacao) {
            const situacoes = {
                0: "Vigente",
                1: "Expirado",
            }
            return situacoes[situacao] || "N/A"
        },
        badgeVariant(situacao) {
            const variants = {
                0: "success",
                1: "danger",
            }
            return variants[situacao] || "secondary"
        },
        limpar() {
            this.form.descricao = "";
            this.load();
        },
        async editar(item) {
            this.id = item.id;
            this.show = true;
        },
        async load() {
            this.filtro = {};

            if (this.form.descricao)
                this.filtro.descricao = this.form.descricao;

            this.busy = true;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });

        },
        cancelar() {
            this.id = null;
            this.show = false;
            this.load();
        },
        mostrarModal() {
            this.id = null;
            this.show = true;
        },

        async rowSelect(item) {
            this.$emit("close", item);
        },

    },
};
</script>
